"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var webpack_merge_1 = require("webpack-merge");
var runner_1 = __importDefault(require("../runner"));
var tauri_config_1 = __importDefault(require("../helpers/tauri-config"));
module.exports = function (config) {
    var tauri = new runner_1.default();
    var tauriConfig = tauri_config_1.default(webpack_merge_1.merge({
        ctx: {
            prod: true
        }
    }, config));
    return {
        runner: tauri,
        promise: tauri.build(tauriConfig)
    };
};
